import {
  useCreateGrowthPlanNoteMutation,
  useDeleteGrowthPlanNoteMutation,
  useGetGrowthPlanNotesListQuery,
  useUpdateGrowthPlanNoteMutation,
} from '../../redux/services/growthPlanNotesAPI';
import {
  useGetProgressNotesListQuery,
  useCreateProgressNotesMutation,
  useEditProgressNotesMutation,
  useDeleteProgressNoteMutation,
} from '../../redux/services/progressNotesAPI';

export const useProgressNotesAPI = (apiType: 'growthPlan' | 'notesAndDocument') => {
  switch (apiType) {
    case 'growthPlan':
      return {
        useGetNotes: useGetGrowthPlanNotesListQuery,
        useCreateNote: useCreateGrowthPlanNoteMutation,
        useEditNote: useUpdateGrowthPlanNoteMutation,
        useDeleteNote: useDeleteGrowthPlanNoteMutation,
      };
    case 'notesAndDocument':
      return {
        useGetNotes: useGetProgressNotesListQuery,
        useCreateNote: useCreateProgressNotesMutation,
        useEditNote: useEditProgressNotesMutation,
        useDeleteNote: useDeleteProgressNoteMutation,
      };
    default:
      throw new Error('Unsupported API type');
  }
};
